import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyDisplayService } from '../../_services/currency-display.service';

@Pipe({
  name: 'cpgcurrency'
})
export class CpgcurrencyPipe implements PipeTransform {

  constructor(
    private currDisplayService: CurrencyDisplayService
  ) {
  }

  transform(num:any, currCode:any): any {
    return this.currDisplayService.getFormattedCurrencyStrForAmountAndCurrency(num, currCode);
  }

}
